


































































































































import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver, extend } from 'vee-validate';
import CloseIcon from 'mdi-vue/Close';
import EyeIcon from 'mdi-vue/Eye';

import format from '@/libs/numberFormat';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Loader from '@/components/Loader.vue';
import FormInput from '@/components/FormInput.vue';
import FileInput from '@/components/FileInput.vue';
import Button from '@/components/Button.vue';
import Modal from '@/components/Modal.vue';
import Select from '@/components/Select.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Pagination from '@/components/Pagination.vue';
import api from '@/libs/api';
import {
  DisbursementMerchantBalanceResponse,
  DisbursementMerchantDetail, DisbursementTopupHistoryResponse,
} from '@/libs/api.interfaces';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import dayjs from 'dayjs';

/* eslint arrow-parens: ["error", "as-needed"] */
extend('min_value', v => {
  if (v >= 10000) {
    return true;
  }
  return 'Minimal value is Rp10.000';
});

@Component({
  components: {
    ValidationObserver,
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    FormInput,
    FileInput,
    Loader,
    Button,
    Modal,
    CloseIcon,
    Select,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Pagination,
    ActionPopup,
    ScrollbarWrapper,
    EyeIcon,
  },
  methods: {
    format,
  },
})
export default class TopUp extends Vue {
  loading = true;
  loadingHistory = true;
  loadingSubmit = false;
  name = '';
  balance = '0';
  topup = ''
  merchantId = '';
  imageURL: string | null = null;
  image: File | null = null;
  showModal = false;
  showConfirm = false;
  history: DisbursementMerchantDetail[] = []

  format!: Function;

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  channels = [
    { label: 'BCA VA', value: '1' },
    { label: 'BNI VA', value: '2' },
    { label: 'Mandiri VA', value: '3' },
  ]

  channel: { label: string; value: string } | null = null;

  $refs!: {
    imageSelector: FileInput;
    observer: InstanceType<typeof ValidationObserver>;
  }

  async getChannel() {
    try {
      const { data } = await api.get('/prepaid/list/bank');
      this.channels = Object.keys(data)
        .map((key: string) => ({
          label: data[key].name.replace('Virtual Account', ''),
          value: data[key].id,
        }));
      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getDetail() {
    try {
      const { data } = await api.get<DisbursementMerchantBalanceResponse>('/prepaid/merchant/balance', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_id: this.$route.params.id,
        },
      });

      const merchant = data.data[0];
      this.name = merchant.name;
      this.merchantId = merchant.id;
      this.balance = merchant.histories ? format(Number(merchant.histories.balance)) : '0';
      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getHistory() {
    try {
      this.loadingHistory = true;
      const { data } = await api.get<DisbursementTopupHistoryResponse>('/prepaid/topup-manual', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_id: this.$route.params.id,
          page: this.page,
        },
      });
      this.totalPage = Math.ceil(data.total / data.per_page);
      this.from = data.from;
      this.to = data.to;
      this.totalItem = data.total;
      this.history = data.data;
      this.loadingHistory = false;
    } catch (err) {
      console.error(err);
      this.loadingHistory = false;
    }
  }

  async submit() {
    try {
      this.loadingSubmit = true;
      const form = new FormData();
      form.append('bank_id', this.channel?.value || '');
      form.append('amount', this.topup);
      form.append('merchant_id', this.merchantId.toString());
      form.append('proof_of_payment', this.image as File);
      await api.post('/prepaid/topup-manual', form);

      setTimeout(() => {
        this.loadingSubmit = false;
        showToast(ToastType.SUCCESS, 'Success', 'Manual Top Up Success');
        this.showConfirm = false;
        this.getDetail();
        this.getHistory();
        this.topup = '';
        this.imageURL = '';
        this.image = null;
        this.channel = null;
        this.$refs.imageSelector.reset();
      }, 3000);
    } catch (err) {
      console.error(err);
      showToast(ToastType.FAILED, 'Error', 'Manual Top Up Failed');
      this.loadingSubmit = false;
      this.showConfirm = false;
    }
  }

  reset() {
    this.topup = '';
    this.imageURL = '';
    this.image = null;
    this.channel = null;
    this.$refs.imageSelector.reset();
  }

  onFileChange(image: File) {
    this.image = image;
    this.imageURL = URL.createObjectURL(image);
  }

  showImage() {
    if (this.image === null) return;
    this.imageURL = URL.createObjectURL(this.image);
    this.showModal = true;
  }

  showImageHistory(image: string) {
    this.imageURL = `${process.env.VUE_APP_API_URL}${image}`;
    this.showModal = true;
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('DD-MM-YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }

  mounted() {
    this.getChannel();
    this.getDetail();
    this.getHistory();
  }
}
